<ng-container *ngIf="currentReport?.CHECK_LIST then check else nocheck"></ng-container>

<ng-template #nocheck>
<!--   <loader></loader> -->
</ng-template>

<ng-template #check>

  <div class="no-dialog" *ngIf="isLoading">
    <div class="loader">
      <loader [loading]="isLoading"></loader>
    </div>
  </div>

  <!-- Entity with Balance Sheet -->
  <div class="row">
    <div class="col-12">
      <div class="section-block">
        <ng-container
          *ngFor="let check of currentReport.CHECK_LIST.ENTITY_CHECK_LIST | orderBy: ['BS_TOGGLE', 'ENTITY.ORDER'];  let i = index;">

          <ng-container *ngIf="check.ENTITY_CHECK_DATE && check.BS_TOGGLE">
            <div class="check-block" [ngClass]="{'override-bordered': check.FINANCIALS_OVERRIDE}">
              <div class="header" [ngClass]="{'override': check.FINANCIALS_OVERRIDE}">
                <div class="text ellipsis">Tax Returns & Financials for {{getEntityName(check.ENTITY)}}</div>

                <div class="actions">
                  <toggle-button [value]="check.BS_TOGGLE" [small]="true" hint="Balance Sheet" icon="bold"
                    (valueChange)="check.BS_TOGGLE = !check.BS_TOGGLE; setToggleField(check.ID, check.BS_TOGGLE, check)"
                    [disabled]="isDisabled || !isActiveEdit()">
                  </toggle-button>

                  <toggle-button [small]="true" [noToggle]="true"
                    hint="Reset Information" icon="repeat" (click)="showFinancialsDialog(check)"
                    [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                  <toggle-button [small]="true" [noToggle]="true" hint="Change Date" icon="calendar-o"
                    (click)="showChangeDateDialog(check)" [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                  <toggle-button [value]="check.BASIS_OVERRIDE" [small]="true" hint="Override Basis" icon="adjust"
                    (valueChange)="check.BASIS_OVERRIDE = !check.BASIS_OVERRIDE;
                                             setDataField(check.ID, 'BASIS_OVERRIDE', check.BASIS_OVERRIDE)"
                    [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                  <toggle-button [value]="check.FINANCIALS_OVERRIDE" [small]="true" hint="Override" icon="strikethrough"
                    (valueChange)="check.FINANCIALS_OVERRIDE = !check.FINANCIALS_OVERRIDE;
                                             setDataField(check.ID, 'FINANCIALS_OVERRIDE', check.FINANCIALS_OVERRIDE)"
                    [disabled]="isDisabled || !isActiveEdit()"></toggle-button>
                </div>
              </div>
              <div class="check-block-content">
                <table class="trf-table">
                  <thead>
                    <tr>
                      <th rowspan="2" style="border-right: 1px solid #d4dce9">Date</th>
                      <th colspan="2" style="border-right: 1px solid #d4dce9">Income Statements
                        <button [disabled]="isDisabled || !isActiveEdit()" class="btn btn-rbv btn-date">
                          <i class="fa fa-calendar" aria-hidden="true"></i> {{ check.ENTITY_CHECK_DATE | formatdate }}
                        </button>
                      </th>
                      <th *ngIf="!check.isDateEqual" rowspan="2" style="border-right: 1px solid #d4dce9">Date</th>
                      <th colspan="2" style="border-right: 1px solid #d4dce9">
                        <div style="display: flex; justify-content: center; align-items: center;">
                           Balance Sheet
                           <button [bsValue]="check.bsDateValue" [id]="'bsDate-'+ check.ENTITY.ID+'-'+i" [name]="'bsDate-'+ check.ENTITY.ID+'-'+i" bsDatepicker
                            [disabled]="isDisabled || !isActiveEdit()" class="btn btn-rbv btn-date" [maxDate]="BS_DATE"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                            (bsValueChange)="setBsDate($event, check)">
                            <i class="fa fa-calendar" aria-hidden="true"></i> {{ check.BS_ENTITY_CHECK_DATE | formatdate }}
                          </button>
                        </div>
                      </th>
                      <th rowspan="2">
                        <div class="full-checked">
                          <label class="checkbox-custom-label" style="font-weight: bold; color: black;"
                            [for]="'selectAll-'+ check.ENTITY.ID+'-'+i">Full</label>

                          <label class="checkbox mb-0 mr-0">{{isAllFullChecked(check)}}
                            <input type="checkbox" class="checkbox__input" [name]="'selectAll-'+ check.ENTITY.ID+'-'+i"
                              [id]="'selectAll-'+ check.ENTITY.ID+'-'+i" ([ngModel])="check.selected" [value]="true" [checked]="check.selected == true"
                                (click)="onSelectAllFull(check)" [disabled]="isDisabled || !isActiveEdit()" >
                            <div class="checkbox__data p-0">
                              <div class="checkbox__indicator"></div>
                              <p class="checkbox__text"></p>
                            </div>
                          </label>
                        </div>
                    </tr>
                    <tr>
                      <th style="border-right: 1px solid #d4dce9">Type</th>
                      <th style="border-right: 1px solid #d4dce9">
                        <div class="basis-checked">
                          <div>Basis</div>
                          <select class="rbv-field" [disabled]="isDisabled || !isActiveEdit()" [(ngModel)]="check.same"
                            (ngModelChange)="onSameSelected(check, $event)"
                            style="border-radius: 0;width: 120px;padding-right: 14px;"
                            [id]="'sameAll-'+ check.ENTITY.ID+'-'+i" [name]="'sameAll-'+ check.ENTITY.ID+'-'+i">
                            <option class="holder" [ngValue]="undefined">Select Basis</option>
                            <option *ngFor="let fin of finBasisValues" [value]="fin.getValue()">
                              {{fin.getName()}}
                            </option>
                          </select>
                        </div>
                      </th>
                      <th style="border-right: 1px solid #d4dce9">Type</th>
                      <th style="border-right: 1px solid #d4dce9">
                        <div class="basis-checked">
                          <div>Basis</div>
                          <select class="rbv-field" [disabled]="isDisabled || !isActiveEdit()"
                            [(ngModel)]="check.bs_same" (ngModelChange)="onBSSameSelected(check, $event)"
                            style="border-radius: 0;width: 120px;padding-right: 14px;"
                            [id]="'sameAll-BS'+ check.ENTITY.ID+'-'+i" [name]="'sameAll-BS'+ check.ENTITY.ID+'-'+i">
                            <option class="holder" [ngValue]="undefined">Select Basis</option>
                            <option *ngFor="let fin of finAllBasisValues" [value]="fin.getValue()">
                              {{fin.getName()}}
                            </option>
                          </select>
                        </div>
                      </th>

                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let is of check.FINANCIALS | orderBy: ['DATE_TS']; let n = index;">
                      <td class="date align-center">
                        {{is.DATE | formatdate}}
                      </td>
                      <td class="type">
                        <input-search placeholder="Type" [regular]="true" [preset]="finTypeValues"
                          [inputValue]="is.TYPE" (valueChange)="finTypeChanged(check.ID, 'TYPE', is, $event)"
                          [disabled]="isDisabled || !isActiveEdit()">
                        </input-search>
                      </td>
                      <td class="basis">
                        <input-search placeholder="Basis" [preset]="finBasisValues" [inputValue]="is.IS_BASIS"
                          [userInputAllowed]="true" (valueChange)="finBasisChanged(check.ID, 'IS_BASIS', is, $event)"
                          [disabled]="isDisabled || !isActiveEdit() || is.isFullDisable()">
                        </input-search>

                        <div class="mt-2">
                          <input-search placeholder="Form" [regular]="true" [preset]="formTypes" [inputValue]="is.TAX_TYPE"
                            (valueChange)="formTypeChanged(check.ID, 'TAX_TYPE', is, $event)" [disabled]="isDisabled || !isActiveEdit()">
                          </input-search>
                        </div>
                      </td>
                      <td *ngIf="!check.isDateEqual" class="date align-center">
                        <span *ngIf="is.BS_DATE">{{is.BS_DATE | formatdate}}</span>
                      </td>
                      <td class="type">
                        <input-search placeholder="Type" [regular]="true" [preset]="finTypeValues"
                          [inputValue]="is.BS_TYPE" (valueChange)="finBSTypeChanged(check.ID, 'BS_TYPE', is, $event)"
                          [disabled]="isDisabled || !isActiveEdit()">
                        </input-search>
                      </td>

                      <td class="basis">
                        <input-search placeholder="Basis" [preset]="finBasisValues" [inputValue]="is.BS_BASIS"
                          [userInputAllowed]="true" (valueChange)="finBSBasisChanged(check.ID, 'BS_BASIS', is, $event)"
                          [disabled]="isDisabled || !isActiveEdit() || is.isBsBasisClear()">
                        </input-search>

                        <div class="mt-2">
                          <input-search placeholder="Form" [regular]="true" [preset]="formTypes" [inputValue]="is.BS_TAX_TYPE"
                            (valueChange)="formBSTypeChanged(check.ID, 'BS_TAX_TYPE', is, $event)" [disabled]="isDisabled || !isActiveEdit()">
                          </input-search>
                        </div>
                      </td>

                      <td class="full align-center">
                        <label class="checkbox  mb-0 mr-0">
                          <input type="checkbox" class="checkbox__input" [name]="'full-'+check.ENTITY.ID+'-'+n"
                            [id]="'full-'+check.ENTITY.ID+'-'+n" [(ngModel)]="is.FULL" [disabled]="isDisabled || !isActiveEdit() || is.isFullDisable()"
                            (ngModelChange)="setDataFinField(check.ID, is.ID, 'FULL', $event)">
                          <div class="checkbox__data p-0">
                            <div class="checkbox__indicator"></div>
                            <p class="checkbox__text"></p>
                          </div>
                        </label>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="6">
                        <div class="checkbox-group inline" style="padding-left: 10px; padding-right: 10px;">

                          <label class="checkbox mb-0">
                            <input type="checkbox" class="checkbox__input" [name]="'accountReceivable-'+ check.ENTITY.ID+'-'+i"
                              [id]="'accountReceivable-'+ check.ENTITY.ID+'-'+i" [(ngModel)]="check.AR"
                              (ngModelChange)="setDataField(check.ID, 'AR', $event)"
                              [disabled]="isDisabled || !isActiveEdit()" >
                            <div class="checkbox__data pl-0 pr-0">
                              <div class="checkbox__indicator"></div>
                              <p class="checkbox__text"> Account Receivable</p>
                            </div>
                          </label>

                          <div *ngIf="check.AR" class="checkbox-item" style="width: 180px;">
                            <input [name]="'accountReceivableDate-'+ check.ENTITY.ID+'-'+i" class="rbv-field form-control rounded-0"
                              [(ngModel)]="check.AR_DATE" #datePicker="bsDatepicker" bsDatepicker placeholder="Date"
                              [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                              [disabled]="isDisabled || !isActiveEdit()" (ngModelChange)="setAccountReceivableDate(check)"
                              [outsideClick]="true"/>
                          </div>

                          <label class="checkbox mb-0">
                            <input type="checkbox" class="checkbox__input" [name]="'accountPayable-'+ check.ENTITY.ID+'-'+i"
                              [id]="'accountPayable-'+ check.ENTITY.ID+'-'+i" [(ngModel)]="check.AP"
                              (ngModelChange)="setDataField(check.ID, 'AP', $event)"
                              [disabled]="isDisabled || !isActiveEdit()" >
                            <div class="checkbox__data pr-0" style="margin-left: 20px;">
                              <div class="checkbox__indicator"></div>
                              <p class="checkbox__text"> Account Payable</p>
                            </div>
                          </label>

                          <div *ngIf="check.AP" class="checkbox-item" style="width: 180px;">
                            <input [name]="'accountPayableDate-'+ check.ENTITY.ID+'-'+i"
                              class="rbv-field form-control rounded-0" [(ngModel)]="check.AP_DATE"
                              #datePicker="bsDatepicker" bsDatepicker placeholder="Date"
                              [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                              [disabled]="isDisabled || !isActiveEdit()" (ngModelChange)="setAccountPayableDate(check)"
                              [outsideClick]="true" />
                          </div>
                        </div>

                      </td>
                    </tr>

                    <tr>
                      <td colspan="6">
                        <div class="row">
                          <div class="col-sm-6">
                            <label> Form of Incorporation
                              <i [tooltip]="businessFormHelpText" class="fa fa-question-circle" [adaptivePosition]="false" placement="right"></i>
                            </label>

                            <input-search [preset]="entityTypes" [regular]="true" #entityType="ngModel" [(ngModel)]="check.ENTITY.TYPE" name="entityType_{{i}}"
                              placeholder="Form of Incorporation" (valueChange)="onBusinessFormValueChanged($event, check.ENTITY)"
                              [disabled]="isDisabled || !isActiveEdit()" ></input-search>
                          </div>

                          <div class="col-sm-6">
                            <label> State of Incorporation</label>

                            <input-search [preset]="stateItems" [regular]="true" [searchable]="true" [(ngModel)]="check.ENTITY.STATE_INCORPORATED" name="businessState_{{i}}"
                              placeholder="State of Incorporation" (valueChange)="onStateValueChange($event, check.ENTITY)"
                              [disabled]="isDisabled || !isActiveEdit()" ></input-search>

                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colspan="6">
                        <div class="row">
                          <div class="col-sm-6">
                            <label>Date of Incorporation
                              <ask *ngIf="isBVQ" [askQuestion]="bvqReport.hasAsk('ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID)"
                                   [fieldName]="'ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID" [disabled]="isDisabled || !isActiveEdit()"
                                   [resendQuestion]="bvqReport.ASK['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.RESEND"
                                   [type]="bvqReport.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.TYPE"></ask>
                            </label>

                            <div class="dateIncorp">
                              <input type="text" class="form-control rounded-0" placeholder="MM/DD/YYYY"
                                name="companyInc" #companyInc="ngModel" [(ngModel)]="check.ENTITY.DATE_INCORPORATED" [disabled]="isDisabled || !isActiveEdit()"
                                (input)="dateMask($event)" (ngModelChange)="checkValidDate(check.ENTITY)" maxlength="10"
                                (blur)="companyIncorporatedChange(check.ENTITY)"
                                [ngClass]="{'error': check.ENTITY.DATE_INCORPORATED && !checkValidDate(check.ENTITY)}" />
                              <span class="help-block required-txt" *ngIf='check.ENTITY.DATE_INCORPORATED && !checkValidDate(check.ENTITY)'>Invalid Date</span>
                            </div>

                            <bvq-source [top]="'26px'" *ngIf="bvqReport"
                              [fieldSource]="bvqReport.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.TYPE"
                                  [fieldNote]="bvqReport?.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.NOTE"
                                  [fieldSourceTitle]="bvqReport?.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.SOURCE_TITLE"
                                  [fieldName]="'ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID"></bvq-source>
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr *ngIf="check.FINANCIALS_OVERRIDE">
                      <td [attr.colspan]="check.isDateEqual ? 6 : 7">
                        <textarea [ngClass]="{'override-reason-green': check.FINANCIALS_OVERRIDE && check.FINANCIALS_REASON}" class="form-control rounded-0 override-reason rbv-field"
                          [(ngModel)]="check.FINANCIALS_REASON" placeholder="Override Reason Explanation"
                          [readonly]="isDisabled || !isActiveEdit()" [disabled]="!isActiveEdit()"
                          (blur)="setDataField(check.ID, 'FINANCIALS_REASON', check.FINANCIALS_REASON)"></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>

        </ng-container>
      </div>
    </div>
  </div>

  <!-- Entity Without Balance Sheet -->
  <div class="row">
    <div [ngClass]="{'col-8': isBVQ != true, 'col-12': isBVQ }">
      <ng-container *ngFor="let check of currentReport.CHECK_LIST.ENTITY_CHECK_LIST | orderBy: ['BS_TOGGLE', 'ENTITY.ORDER']; let i = index;">
        <ng-container *ngIf="!check.ENTITY_CHECK_DATE && !check.BS_TOGGLE">
          <div class="check-block">
            <div class="header">
              <div class="text ellipsis">Tax Returns & Financials for {{getEntityName(check.ENTITY)}}</div>

              <div class="actions"></div>
            </div>

            <div class="check-block-content min">

              <button type="button" *ngIf="!check.ENTITY.IS_DEFAULT && currentReport?.CHECK_LIST.isPrimaryEntityHaveDate" class="btn btn-rbv wide" (click)="oncopyYears(check)"
                [disabled]="isDisabled || !isActiveEdit()">
                <fa name="fa fa-clone"></fa>
                Copy Years
              </button>

              <button type="button" class="btn btn-rbv wide" (click)="showFinancialsDialog(check)"
                [disabled]="isDisabled || !isActiveEdit()">
                <fa name="fa fa-calendar"></fa>
                Setup Years
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="check.ENTITY_CHECK_DATE && !check.BS_TOGGLE">
          <div class="check-block" [ngClass]="{'override-bordered': check.FINANCIALS_OVERRIDE}">
            <div class="header" [ngClass]="{'override': check.FINANCIALS_OVERRIDE}">
              <div class="text ellipsis" [tooltip]="getEntityName(check.ENTITY)">Tax Returns & Financials for {{getEntityName(check.ENTITY)}}</div>

              <div class="actions">
                <toggle-button [value]="check.BS_TOGGLE" [small]="true" hint="Balance Sheet" icon="bold"
                  (valueChange)="check.BS_TOGGLE = !check.BS_TOGGLE; setToggleField(check.ID, check.BS_TOGGLE, check)"
                  [disabled]="isDisabled || !isActiveEdit()">
                </toggle-button>

                <toggle-button [small]="true" [noToggle]="true" hint="Reset Information" icon="repeat"
                  (click)="showFinancialsDialog(check)" [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                <toggle-button [small]="true" [noToggle]="true" hint="Change Date" icon="calendar-o"
                  (click)="showChangeDateDialog(check)" [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                 <toggle-button [value]="check.BASIS_OVERRIDE" [small]="true" hint="Override Basis" icon="adjust"
                    (valueChange)="check.BASIS_OVERRIDE = !check.BASIS_OVERRIDE;
                                             setDataField(check.ID, 'BASIS_OVERRIDE', check.BASIS_OVERRIDE)"
                    [disabled]="isDisabled || !isActiveEdit()"></toggle-button>

                <toggle-button [value]="check.FINANCIALS_OVERRIDE" [small]="true" hint="Override" icon="strikethrough" (valueChange)="check.FINANCIALS_OVERRIDE = !check.FINANCIALS_OVERRIDE;
                                             setDataField(check.ID, 'FINANCIALS_OVERRIDE', check.FINANCIALS_OVERRIDE)"
                  [disabled]="isDisabled || !isActiveEdit()"></toggle-button>
              </div>
            </div>

            <div class="check-block-content">
              <table class="trf-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Form</th>
                    <th>
                      <div class="basis-checked">
                        <div>Basis</div>
                        <select class="rbv-field" [disabled]="isDisabled || !isActiveEdit()" [(ngModel)]="check.same"
                                (ngModelChange)="onSameSelected(check, $event)" style="border-radius: 0;width: 120px;padding-right: 14px;"
                                [id]="'sameAll-'+ check.ENTITY.ID+'-'+i" [name]="'sameAll-'+ check.ENTITY.ID+'-'+i" >
                          <option class="holder" [ngValue]="undefined">Select Basis</option>
                          <option *ngFor="let fin of finAllBasisValues" [value]="fin.getValue()">
                            {{fin.getName()}}
                          </option>
                        </select>
                      </div>
                    </th>
                    <th>
                      <div class="full-checked">
                        <label class="checkbox-custom-label" style="font-weight: bold; color: black;" [for]="'selectAll-'+ check.ENTITY.ID+'-'+i">Full</label>
                         <label class="checkbox mb-2 mr-0">{{isAllFullChecked(check)}}
                          <input type="checkbox" class="checkbox__input" [name]="'selectAll-'+ check.ENTITY.ID+'-'+i"
                            [id]="'selectAll-'+ check.ENTITY.ID+'-'+i" ([ngModel])="check.selected" [value]="true" [checked]="check.selected == true"
                              (click)="onSelectAllFull(check)" [disabled]="isDisabled || !isActiveEdit()" >
                          <div class="checkbox__data p-0">
                            <div class="checkbox__indicator"></div>
                            <p class="checkbox__text"></p>
                          </div>
                        </label>
                      </div>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let is of check.FINANCIALS | orderBy: ['YEAR']; let n = index;">
                    <td class="date align-center">
                      {{is.DATE | formatdate}}
                    </td>
                    <td class="type">
                      <input-search placeholder="Type" [regular]="true" [preset]="finTypeValues" [inputValue]="is.TYPE"
                        (valueChange)="finTypeChanged(check.ID, 'TYPE', is, $event)" [disabled]="isDisabled || !isActiveEdit()">
                      </input-search>
                    </td>
                    <td class="form">
                      <input-search [isWidth]="true" placeholder="Form" [regular]="true" [preset]="formTypes" [inputValue]="is.TAX_TYPE"
                        (valueChange)="formTypeChanged(check.ID, 'TAX_TYPE', is, $event)" [disabled]="isDisabled || !isActiveEdit()">
                      </input-search>
                    </td>
                    <td class="basis">
                      <input-search placeholder="Basis" [preset]="finBasisValues" [inputValue]="is.IS_BASIS"
                        [userInputAllowed]="true" (valueChange)="finBasisChanged(check.ID, 'IS_BASIS', is, $event)" [disabled]="isDisabled || !isActiveEdit() || is.isFullDisable()">
                      </input-search>
                    </td>

                    <td class="full align-center">

                      <label class="checkbox mb-0 mr-0">
                        <input type="checkbox" class="checkbox__input" [name]="'full-'+check.ENTITY.ID+'-'+n"
                          [id]="'full-'+check.ENTITY.ID+'-'+n" [(ngModel)]="is.FULL" [disabled]="isDisabled || !isActiveEdit() || is.isFullDisable()"
                          (ngModelChange)="setDataFinField(check.ID, is.ID, 'FULL', $event)">
                        <div class="checkbox__data p-0">
                          <div class="checkbox__indicator"></div>
                          <p class="checkbox__text"></p>
                        </div>
                      </label>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="6">
                      <div class="checkbox-group inline" style="padding-left: 10px; padding-right: 10px;">

                        <label class="checkbox mb-0">
                          <input type="checkbox" class="checkbox__input" [name]="'accountReceivable-'+ check.ENTITY.ID+'-'+i"
                            [id]="'accountReceivable-'+ check.ENTITY.ID+'-'+i" [(ngModel)]="check.AR"
                            (ngModelChange)="setDataField(check.ID, 'AR', $event)" [disabled]="isDisabled || !isActiveEdit()">
                          <div class="checkbox__data pl-0 pr-0">
                            <div class="checkbox__indicator"></div>
                            <p class="checkbox__text"> Account Receivable</p>
                          </div>
                        </label>


                        <div *ngIf="check.AR" class="checkbox-item" style="width: 180px;">
                          <input [name]="'accountReceivableDate-'+ check.ENTITY.ID+'-'+i" class="rbv-field form-control rounded-0"
                            [(ngModel)]="check.AR_DATE" #datePicker="bsDatepicker" bsDatepicker placeholder="Date"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                            [disabled]="isDisabled || !isActiveEdit()" (ngModelChange)="setAccountReceivableDate(check)"
                            [outsideClick]="true"/>
                        </div>

                        <label class="checkbox mb-0">
                          <input type="checkbox" class="checkbox__input" [name]="'accountPayable-'+ check.ENTITY.ID+'-'+i"
                            [id]="'accountPayable-'+ check.ENTITY.ID+'-'+i" [(ngModel)]="check.AP"
                            (ngModelChange)="setDataField(check.ID, 'AP', $event)" [disabled]="isDisabled || !isActiveEdit()" >
                          <div class="checkbox__data pr-0" style="margin-left: 20px;">
                            <div class="checkbox__indicator"></div>
                            <p class="checkbox__text"> Account Payable</p>
                          </div>
                        </label>

                        <div *ngIf="check.AP" class="checkbox-item" style="width: 180px;">
                          <input [name]="'accountPayableDate-'+ check.ENTITY.ID+'-'+i" class="rbv-field form-control rounded-0"
                          [(ngModel)]="check.AP_DATE" #datePicker="bsDatepicker" bsDatepicker placeholder="Date"
                            [bsConfig]="{dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-blue', showWeekNumbers: false}"
                            [disabled]="isDisabled || !isActiveEdit()" (ngModelChange)="setAccountPayableDate(check)"
                            [outsideClick]="true" />
                        </div>
                      </div>

                    </td>
                  </tr>

                  <tr>
                    <td colspan="6">
                      <div class="row">
                        <div class="col-sm-6">
                          <label>Form of Incorporation
                            <i [tooltip]="businessFormHelpText" class="fa fa-question-circle" [adaptivePosition]="false" placement="right"></i>
                          </label>

                          <input-search [preset]="entityTypes" [regular]="true" #entityType="ngModel" [(ngModel)]="check.ENTITY.TYPE" name="entityType_{{i}}"
                            placeholder="Form of Incorporation" (valueChange)="onBusinessFormValueChanged($event, check.ENTITY)"
                            [disabled]="isDisabled || !isActiveEdit()" ></input-search>
                        </div>

                        <div class="col-sm-6">
                          <label>State of Incorporation</label>

                          <input-search [preset]="stateItems" [regular]="true" [searchable]="true" [(ngModel)]="check.ENTITY.STATE_INCORPORATED" name="businessState_{{i}}"
                            placeholder="State of Incorporation" (valueChange)="onStateValueChange($event, check.ENTITY)"
                            [disabled]="isDisabled || !isActiveEdit()" ></input-search>

                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="6">
                      <div class="row">
                        <div class="col-sm-6">
                          <label>Date of Incorporation
                            <ask *ngIf="isBVQ" [askQuestion]="bvqReport.hasAsk('ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID)"
                                 [fieldName]="'ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID" [disabled]="isDisabled || !isActiveEdit()"
                                 [resendQuestion]="bvqReport.ASK['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.RESEND"
                                 [type]="bvqReport.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.TYPE"></ask>
                          </label>

                          <div class="dateIncorp">
                            <input type="text" class="form-control rounded-0" placeholder="MM/DD/YYYY"
                              name="companyInc" #companyInc="ngModel" [(ngModel)]="check.ENTITY.DATE_INCORPORATED" [disabled]="isDisabled || !isActiveEdit()"
                              (input)="dateMask($event)" (ngModelChange)="checkValidDate(check.ENTITY)" maxlength="10"
                              (blur)="companyIncorporatedChange(check.ENTITY)"
                              [ngClass]="{'error': check.ENTITY.DATE_INCORPORATED && !checkValidDate(check.ENTITY)}" />
                            <span class="help-block required-txt" *ngIf='check.ENTITY.DATE_INCORPORATED && !checkValidDate(check.ENTITY)'>Invalid Date</span>
                          </div>

                           <bvq-source  [top]="'26px'" *ngIf="bvqReport"
                            [fieldSource]="bvqReport?.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.TYPE"
                                  [fieldNote]="bvqReport?.SOURCES['ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID]?.NOTE"
                                  [fieldName]="'ENTITIES-DATE_INCORPORATED:'+check.ENTITY.ID"></bvq-source>

                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr *ngIf="check.FINANCIALS_OVERRIDE">
                    <td colspan="6">
                      <textarea [ngClass]="{'override-reason-green': check.FINANCIALS_OVERRIDE && check.FINANCIALS_REASON}"
                        class="form-control rounded-0 override-reason rbv-field" [(ngModel)]="check.FINANCIALS_REASON"
                        placeholder="Override Reason Explanation" [readonly]="isDisabled || !isActiveEdit()" [disabled]="!isActiveEdit()"
                        (blur)="setDataField(check.ID, 'FINANCIALS_REASON', check.FINANCIALS_REASON)"></textarea>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- Purchase Agreement Block -->
      <div class="check-block">
        <div class="header">
          <div class="text">Purchase Agreement</div>
        </div>

        <div class="d-flex flex-column p-2">

          <label class="checkbox mb-0">
            <input type="checkbox" class="checkbox__input" name="paOrLoi" id="paOrLoiPa"
              [(ngModel)]="currentReport.CHECK_LIST.P_PA"
              (ngModelChange)="setPurchaseAgreementField('P_PA', $event)"
              [disabled]="isDisabled || !isActiveEdit()">
            <div class="checkbox__data">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text">Purchase Agreement </p>
            </div>
          </label>

          <div class="child-list" *ngIf="currentReport.CHECK_LIST.P_PA === true">

            <div class="radio-item">
              <input class="radio-custom" type='radio' name="pAgreementType" id="paStock"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.STOCK)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.STOCK"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.STOCK"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="paStock">Stock (Equity)</label>
            </div>

            <div class="radio-item">
              <input class="radio-custom" type='radio' name="pAgreementType" id="paAsset"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.ASSET)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.ASSET"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.ASSET"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="paAsset">Asset</label>
            </div>

            <div class="radio-item">
              <input class="radio-custom" type='radio' name="pAgreementType" id="tobeDetermined"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.TO_BE_DETERMINED)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.TO_BE_DETERMINED"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.TO_BE_DETERMINED"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="tobeDetermined">To Be Determined</label>
            </div>
          </div>

          <label class="checkbox mb-0 mt-2">
            <input type="checkbox" class="checkbox__input" name="paOrLoi" id="paOrLoiLoi"
              [(ngModel)]="currentReport.CHECK_LIST.P_LOIP"
              (ngModelChange)="setPurchaseAgreementField('P_LOIP', $event)"
              [disabled]="isDisabled || !isActiveEdit()">
            <div class="checkbox__data">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text">Letter of Intent to Purchase </p>
            </div>
          </label>

          <div class="child-list" *ngIf="currentReport.CHECK_LIST.P_LOIP === true">
            <div class="radio-item">
              <input class="radio-custom" type='radio' name="letterOfIntentType" id="loiStock"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.STOCK)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.STOCK"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.STOCK"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="loiStock">Stock (Equity)</label>
            </div>

            <div class="radio-item">
              <input class="radio-custom" type='radio' name="letterOfIntentType" id="loiAsset"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.ASSET)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.ASSET"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.ASSET"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="loiAsset">Asset</label>
            </div>
          </div>

          <label class="checkbox mb-0 mt-2">
            <input type="checkbox" class="checkbox__input" name="paOrLoi" id="paOrLoiNa"
              [(ngModel)]="currentReport.CHECK_LIST.P_NA"
              (ngModelChange)="setPurchaseAgreementField('P_NA', $event)"
              [disabled]="isDisabled || !isActiveEdit()">
            <div class="checkbox__data">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text">Not Available </p>
            </div>
          </label>

          <div class="child-list" *ngIf="currentReport.CHECK_LIST.P_NA === true">
            <div class="radio-item">
              <input class="radio-custom" type='radio' name="notAvailableType" id="naStock"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.STOCK)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.STOCK"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.STOCK"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="naStock">Stock (Equity)</label>
            </div>

            <div class="radio-item">
              <input class="radio-custom" type='radio' name="notAvailableType" id="naAsset"
                (click)="clearSelf('PURCHASE_AGREEMENT_TYPE', PurchaseAgreementType.ASSET)"
                [(ngModel)]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE" [value]="PurchaseAgreementType.ASSET"
                [checked]="currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.ASSET"
                (ngModelChange)="setFieldValuationType('PURCHASE_AGREEMENT_TYPE', $event)"
                [disabled]="isDisabled || !isActiveEdit()" />
              <label class="radio-custom-label" for="naAsset">Asset</label>
            </div>

            <div class="form-group"
              *ngIf="currentReport.CHECK_LIST.P_NA === true && (currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.STOCK || currentReport.CHECK_LIST.PURCHASE_AGREEMENT_TYPE === PurchaseAgreementType.ASSET)">
              <label>Explanation</label>
              <textarea class="form-control rounded-0 rbv-field" placeholder="Where you got the Information?"
                [(ngModel)]="currentReport.CHECK_LIST.EXPLANATION" [disabled]="isDisabled || !isActiveEdit()"
                (blur)="setField('EXPLANATION', currentReport.CHECK_LIST.EXPLANATION)"></textarea>
            </div>
          </div>
        </div>
      </div>

      <!--Miscs Block-->
      <div class="check-block">
        <div class="header">
          <div class="text">Miscs</div>
        </div>

        <div class="check-block-content padded">

           <label class="checkbox mb-0">
            <input type="checkbox" class="checkbox__input"  name="paSbaP" id="paSbaP"
              [(ngModel)]="currentReport.CHECK_LIST.SBA_PURPOSE"
              (ngModelChange)="setPurchaseAgreementField('SBA_PURPOSE', $event)"
              [disabled]="isDisabled || !isActiveEdit()">
            <div class="checkbox__data">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text">SBA Purposes </p>
            </div>
          </label>

          <div class="row mt-2">
            <div class="col-6">
              <label>Reason of Valuation</label>

              <input-search [preset]="reasonForValuation" [regular]="true" name="VALUATION_REASON_TYPE"
                #VALUATION_REASON_TYPE="ngModel" placeholder="Reason of Valuation"
                [(ngModel)]="currentReport.CHECK_LIST.VALUATION_REASON_TYPE"
                (valueChange)="onValuationReasontypeChanged($event, check.ENTITY)"
                [disabled]="isDisabled || !isActiveEdit()" ></input-search>
            </div>
          </div>
        </div>
      </div>

      <!-- Real Estate Block -->
      <div class="check-block">
        <div class="header">
          <div class="text">Real Estate</div>
        </div>

        <div class="check-block-content padded">
          <label class="checkbox mb-0">
            <input type="checkbox" class="checkbox__input" name="ownRE" id="ownRE" [(ngModel)]="currentReport.CHECK_LIST.RE_OWNED"
                   (ngModelChange)="setField('RE_OWNED', $event)" [disabled]="isDisabled || !isActiveEdit()">
            <div class="checkbox__data pl-0 pr-0">
              <div class="checkbox__indicator"></div>
              <p class="checkbox__text"> Does the owner or a related party own the Real Estate from which the Company operates? </p>
            </div>
          </label>

          <div class="child-list" *ngIf="currentReport.CHECK_LIST.RE_OWNED === true">

            <label class="checkbox mb-0">
              <input type="checkbox" class="checkbox__input" name="reAppraisal" id="reAppraisal" [disabled]="isDisabled || !isActiveEdit()"
                     [(ngModel)]="currentReport.CHECK_LIST.RE_OWNED_APPRAISAL" (ngModelChange)="setField('RE_OWNED_APPRAISAL', $event)">
              <div class="checkbox__data pl-0 pr-0">
                <div class="checkbox__indicator"></div>
                <p class="checkbox__text"> Copy of Real Estate Appraisal </p>
              </div>
            </label>

            <label class="checkbox mb-0">
              <input type="checkbox" class="checkbox__input" name="reAppraisalContact" id="reAppraisalContact" [disabled]="isDisabled || !isActiveEdit()"
                     [(ngModel)]="currentReport.CHECK_LIST.RE_OWNED_APPRAISAL_CONTACT" (ngModelChange)="setField('RE_OWNED_APPRAISAL_CONTACT', $event)">
              <div class="checkbox__data pl-0 pr-0">
                <div class="checkbox__indicator"></div>
                <p class="checkbox__text"> Real Estate Appraiser's Contact Information </p>
              </div>
            </label>
          </div>

        </div>
      </div>

      <!-- Real Estate Appraiser's Contact Information -->
      <div class="check-block" *ngIf="currentReport.CHECK_LIST.RE_OWNED_APPRAISAL_CONTACT === true">
        <div class="header">
          <div class="text">Real Estate Appraiser's Contact Information</div>
        </div>

        <div class="check-block-content padded">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-0" style="width: 100%;">
                <label class="rbv-label">Name</label>
                <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.RE_CONTACT_NAME" [provider]="checkListProvider"
                            [id]="currentReport.ID" [fieldName]="'RE_CONTACT_NAME'" placeholder="Contact Name" [showButton]="false" (onValueTouched)="onValueTouched($event)"></input-data>
              </div>
            </div>
            <div class="col-md-6">
              <label class="rbv-label">Email</label>
              <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.RE_CONTACT_EMAIL" [provider]="checkListProvider"
                          [id]="currentReport.ID" [fieldName]="'RE_CONTACT_EMAIL'" placeholder="Contact Email" [showButton]="false" (onValueTouched)="onValueTouched($event)"></input-data>
            </div>
          </div>

          <div class="row" style="margin-top: 10px;">
            <div class="col-md-6">
              <div class="form-group mb-0" style="width: 100%;">
                <label class="rbv-label">Company</label>
                <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.RE_CONTACT_COMPANY" [provider]="checkListProvider"
                            [id]="currentReport.ID" [fieldName]="'RE_CONTACT_COMPANY'" placeholder="Contact Company" [showButton]="false" (onValueTouched)="onValueTouched($event)"></input-data>
              </div>
            </div>
            <div class="col-md-6">
              <label class="rbv-label">Phone</label>
              <input-data [disabled]="isDisabled || !isActiveEdit()" [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.RE_CONTACT_PHONE" [provider]="checkListProvider"
                          [id]="currentReport.ID" [fieldName]="'RE_CONTACT_PHONE'" placeholder="(000)-000-0000" [showButton]="false"
                          [inputMask]="'(000) 000-0000'" (onValueTouched)="onValueTouched($event)"></input-data>
            </div>
          </div>
        </div>

      </div>

      <!-- Other Documents -->
      <div class="check-block">
        <div class="header">
          <div class="text">Other Documents</div>

          <div class="actions">
              <toggle-button [small]="true" [noToggle]="true" hint="Add Custom Document" icon="plus"
                (click)="addCustomDocument()" [disabled]="isDisabled || !isActiveEdit()"></toggle-button>
          </div>
        </div>

        <div class="check-block-content padded">
          <div class="row">
            <div class="col-md-1">
              <label class="header-text">Have</label>
            </div>
            <div class="col-md-1">
              <label class="header-text">NA</label>
            </div>
            <div class="col-md-10">
              <label class="header-text">Document Name</label>
            </div>
          </div>

          <!--Financial Projections-->
          <div class="row doc-item">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="finForecastHave" id="finForecastHave"
                      [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.FIN_FORECAST === true"
                      (click)="onDocumentClick('FIN_FORECAST', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="finForecastNA" id="finForecastNA"
                     [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.FIN_FORECAST === false"
                     (click)="onDocumentClick('FIN_FORECAST', false)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>
            <div class="col-md-4">
              <span class="doc_name">Financial Projections</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.FIN_FORECAST === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.FIN_FORECAST_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="FIN_FORECAST_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!-- Credit Write-Up-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="cwuHave" id="cwuHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.CWU === true"
                  (click)="onDocumentClick('CWU', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="cwuNA" id="cwuNA"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.CWU === false"
                  (click)="onDocumentClick('CWU', false)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">Credit Write-Up</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.CWU === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.CWU_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="CWU_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--Commitment Letter-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="cl_loifHave" id="cl_loifHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.CL_LOIF === true"
                   (click)="onDocumentClick('CL_LOIF', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="cl_loifNA" id="cl_loifNA"
                    [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.CL_LOIF === false"
                   (click)="onDocumentClick('CL_LOIF', false)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">Commitment Letter</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.CL_LOIF === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.CL_LOIF_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="CL_LOIF_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--Letter of Intent to Finance-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="loifHave" id="loifHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.LOIF === true"
                   (click)="onDocumentClick('LOIF', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="loifNA" id="loifNA"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.LOIF === false"
                    (click)="onDocumentClick('LOIF', false)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">Letter of Intent to Finance</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.LOIF === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.LOIF_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="LOIF_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--RBV Order Form-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="orderFormHave" id="orderFormHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.ORDER_FORM === true"
                   (click)="onDocumentClick('ORDER_FORM', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="orderFormNA" id="orderFormNA"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.ORDER_FORM === false"
                  (click)="onDocumentClick('ORDER_FORM', false)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">RBV Order Form</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.ORDER_FORM === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.ORDER_FORM_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="ORDER_FORM_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--Business Valuation Questionnaire-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="bvqFieldHave" id="bvqFieldHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.BVQ_FORM === true"
                   (click)="onDocumentClick('BVQ_FORM', true)">
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
               <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="bvqFieldNA" id="bvqFieldNA"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.BVQ_FORM === false"
                   (click)="onDocumentClick('BVQ_FORM', false)"/>
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">Business Valuation Questionnaire</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.BVQ_FORM === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.BVQ_FORM_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="BVQ_FORM_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--Business Plan-->
          <div class="row doc-item mt-1">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="businessPlanHave" id="businessPlanHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.BUSINESS_PLAN === true"
                   (click)="onDocumentClick('BUSINESS_PLAN', true)"/>
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="businessPlanNA" id="businessPlanNA"
                    [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.BUSINESS_PLAN === false"
                   (click)="onDocumentClick('BUSINESS_PLAN', false)"/>
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">Business Plan</span>
            </div>

            <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.BUSINESS_PLAN === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.BUSINESS_PLAN_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="BUSINESS_PLAN_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <!--FDD-->
          <div class="row doc-item mt-1" *ngIf="currentReport.IS_FRANCHISE">
            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="fddHave" id="fddHave"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.FDD === true"
                   (click)="onDocumentClick('FDD', true)"/>
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-1">
              <label class="checkbox mb-0">
                <input type="checkbox" class="checkbox__input" name="fddNa" id="fddNa"
                  [disabled]="isDisabled || !isActiveEdit()" [checked]="currentReport.CHECK_LIST.FDD === false"
                   (click)="onDocumentClick('FDD', false)"/>
                <div class="checkbox__data pl-0 pr-0">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text"></p>
                </div>
              </label>
            </div>

            <div class="col-md-4">
              <span class="doc_name">FDD</span>
            </div>

             <div class="col-md-6" *ngIf="currentReport.CHECK_LIST.FDD === false">
               <input-data [type]="typeOfInput.TEXT" [(ngModel)]="currentReport.CHECK_LIST.FDD_NA_REASON" [provider]="checkListProvider"
                    [id]="currentReport.ID" fieldName="FDD_NA_REASON" [maxLength]="150" placeholder="Reason"
                    [disabled]="isDisabled || !isActiveEdit()" [showButton]="showButton"></input-data>
            </div>
          </div>

          <div class="mt-1" *ngFor="let document of currentReport.CHECK_LIST.CUSTOM_DOCUMENTS | orderBy: ['ID']">
            <custom-document placeholder="Custom Documents" [disabled]="isDisabled || !isActiveEdit()" [document]="document"
            (valueChange)="onCustomDocumentValueChanged($event)"
            (remove)="onRemove($event, document)" [editFlag]="newDoc && newDoc.ID === document.ID ? true : false">
          </custom-document>
          </div>
        </div>
      </div>
    </div>

    <div class="col-4" *ngIf="isBVQ != true">

      <!-- Engagement Letter -->
      <div class="section-block" *ngIf="!currentReport.DOCUMENT_ID && this.currentReport.DOCUMENTS.length === 0 && currentReport.STAGE.ORDER >= 5">
        <div class="section-header" (click)="isCollapsed = !isCollapsed"
             [attr.aria-expanded]="!isCollapsed" aria-controls="collapseEvent">
          <fa [name]="isCollapsed ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Engagement Letter</div>
        </div>

        <p style="text-align: center;margin-top: 10px;font-weight: bold;color: red;">Engaged Manually</p>
      </div>

      <div class="section-block" *ngIf="currentReport.DOCUMENT_ID">
        <div class="section-header" (click)="isCollapsed = !isCollapsed"
             [attr.aria-expanded]="!isCollapsed" aria-controls="collapseEvent">
          <fa [name]="isCollapsed ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Engagement Letter</div>
        </div>

        <div class="report-summary" [collapse]="!isCollapsed">

          <!-- Document ID -->
          <div class="row">
            <div class="col-12 ref_id">
              {{currentReport.DOCUMENT_ID}}
            </div>
          </div>

          <!-- State -->
          <div class="row">
            <div class="col-5">
              <div class="label">State:</div>
            </div>

            <div class="col-7" [ngSwitch]="currentReport.DOCUMENT_STATE">
              <div class="state value" *ngSwitchCase="RSState.draft">
                Draft
              </div>
              <div class="state value" *ngSwitchCase="RSState.pending">
                Pending
              </div>
              <div class="state value" *ngSwitchCase="RSState.executed">
                Executed
              </div>
              <div class="state value" *ngSwitchCase="RSState.voided">
                Voided
              </div>
              <div class="state value" *ngSwitchCase="RSState.expired">
                Expired
              </div>
            </div>
          </div>

          <!-- Created -->
          <div class="row">
            <div class="col-5">
              <div class="label">Created:</div>
            </div>
            <div class="col-7">
              <div class="date value hinted">
                {{currentReport.DATE_ENGAGED_LETTER | amTimeAgo}}
                <div class="hint">{{currentReport.DATE_ENGAGED_LETTER | date: 'MM/dd/yy hh:mm:ss a'}}</div>
              </div>
            </div>
          </div>

          <!-- Executed -->
          <div class="row" *ngIf="currentReport.DOCUMENT_STATE === RSState.executed">
            <div class="col-5">
              <div class="label">Executed:</div>
            </div>
            <div class="col-7">
              <div class="date value hinted">
                {{currentReport.DATE_ENGAGED | amTimeAgo}}
                <div class="hint">{{currentReport.DATE_ENGAGED | date: 'MM/dd/yy hh:mm:ss a'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="validation" *ngIf="!isDisabled">

        <ng-container *ngFor="let check of currentReport.CHECK_LIST.ENTITY_CHECK_LIST | orderBy: ['ID']">
          <ng-container *ngIf="check.validateTaxReturns; let trv">
            <div class="validation-block" [ngClass]="{'success': trv.length === 0}">
              <div class="indicator"></div>

              <div class="info">
                <div class="header collapsible" [attr.aria-expanded]="!check.isCollapsed" aria-controls="collapseEvent"
                  (click)="check.isCollapsed = !check.isCollapsed">
                    Tax Returns & Financials for <div class="ellipsis" [tooltip]="getEntityName(check.ENTITY)">{{getEntityName(check.ENTITY)}}</div>

                  <div *ngIf="check.isCollapsed && trv.length !==0" class="error">
                    There is errors for Entity, please click for more details…
                  </div>
                </div>

                <div class="description" *ngIf="trv.length === 0">
                  All Checks are Passed
                </div>

                <div [collapse]="check.isCollapsed" class="error" *ngFor="let err of trv">
                  - {{err}}
                </div>

              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Purchase Agreement -->
        <ng-container *ngIf="currentReport.CHECK_LIST.validatePurchaseAgreement; let pav">
          <div class="validation-block" [ngClass]="{'success': pav.length === 0}">
            <div class="indicator"></div>

            <div class="info">
              <div class="header">Purchase Agreement</div>

              <div class="description" *ngIf="pav.length === 0">
                All Checks are Passed
              </div>

              <div class="error" *ngFor="let err of pav">
                - {{err}}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Reason of Valuation -->
        <ng-container *ngIf="currentReport.CHECK_LIST.validateReasonOfValuation; let pav">
          <div class="validation-block" [ngClass]="{'success': pav.length === 0}">
            <div class="indicator"></div>

            <div class="info">
              <div class="header">Reason of Valuation</div>

              <div class="description" *ngIf="pav.length === 0">
                All Checks are Passed
              </div>

              <div class="error" *ngFor="let err of pav">
                - {{err}}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Engagement Information -->
        <ng-container *ngIf="currentReport.validateAll; let rev">
          <div class="validation-block" [ngClass]="{'success': rev.length === 0}">
            <div class="indicator"></div>

            <div class="info">
              <div class="header">Engagement Information</div>

              <div class="description" *ngIf="rev.length === 0">
                All Checks are Passed
              </div>

              <div class="error" *ngFor="let err of rev">
                <ng-container
                  *ngIf="err === 'Client User has no Name' || err === 'Client User has no Firstname' || err === 'Client
                  User has no Lastname' || err === 'Client User has no Email Address' ||
                  err === 'Client User has no Address' || err === 'Client User has no City' || err === 'Client User has no State' ||
                  err === 'Client User has no Zip'; else nextError">
                  - <a (click)="onEditClientUser()" class="error" href="javascript:void(0)">{{err}}</a>
                </ng-container>


                <ng-template #nextError>
                  - {{err}}
                </ng-template>

              </div>
            </div>
          </div>
        </ng-container>

        <!-- All Entities Tax Returns & Financials -->
        <ng-container
          *ngIf="currentReport?.CHECK_LIST.validateFinancialSetup && currentReport.CHECK_LIST.ValidateEntityBasis; let pav">
          <div class="validation-block" [ngClass]="{'success': pav.length === 0}">
            <div class="indicator"></div>

            <div class="info">
              <div class="header">All Entities Tax Returns & Financials</div>

              <div class="description" *ngIf="pav.length === 0">
                Basis for All Entities match
              </div>

              <div class="error" *ngFor="let err of pav">
                - {{err}}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="currentReport?.STAGE?.ORDER < 5 || !isDisabled">
          <ng-container *ngIf="currentReport.CHECK_LIST.isValid && currentReport.isValid; then ready else notReady"></ng-container>
        </ng-container>

        <!-- Ready to Engage -->
        <ng-template #ready>
          <div class="validation-result">
            <fa name="fa fa-check-circle"></fa>
            <div class="text">Ready to Engage</div>
          </div>
        </ng-template>

        <!-- Not Ready to Engage -->
        <ng-template #notReady>
          <div class="validation-result error">
            <fa name="fa fa-exclamation-triangle"></fa>
            <div class="text">Not Ready to Engage</div>
          </div>
        </ng-template>
      </div>

      <!-- Actions -->
      <div class="report-actions">
        <button type=" button" class="btn btn-rbv primary full-width"
            [disabled]="!isActiveEdit() || !(currentReport.CHECK_LIST.isValid && currentReport.isValid) || !isDocuSignActive()"
            (click)="showEngage()">
          Engage via <img src="/assets/images/docusign.png" style="height: 24px;"/>
        </button>

        <button type="button" class="btn btn-rbv warning full-width" (click)="showEngageManual()"
            [disabled]="!isActiveEdit() || !(currentReport.CHECK_LIST.isValid && currentReport.isValid) || isEngageModalOpen"
             style="margin-top: 10px;">
            Engage Without DocuSign
        </button>

        <button type="button" *ngIf="!isDisabled || (currentReport?.STAGE?.ORDER < 5 && currentReport?.INITIAL_SENT !== true)"
                class="btn btn-rbv full-width" (click)="showInfo()" style="margin-top: 10px;">
            Initial Email (No Engagement Letter)
        </button>

        <!--Shows only for old way-->
        <button *ngIf="currentReport.DOCUMENT_ID && currentReport.DOCUMENTS.length === 0 && currentReport.DOCUMENT_STATE === RSState.pending"
            type="button" class="btn btn-rbv full-width" (click)="remindClient()" style="margin-top: 10px;">
          Remind Client
        </button>

        <!--Shows only for old way-->
        <div class="d-flex align-items-center preview-wrapper">
          <div style="margin-top: 9px;" *ngIf="currentReport.STAGE.ORDER >= 5">
            <custom-download-preview [previewOnly]="true" [report]="currentReport"></custom-download-preview>
          </div>
          <button [disabled]="!(currentReport.CHECK_LIST.isValid && currentReport.isValid) || isLoadingPreview"
              type="button" class="btn btn-rbv full-width" (click)="onDownloadPdf()" style="margin-top: 10px;">
              <span class="loading-icon-small" *ngIf="isLoadingPreview"></span>
              Download Engagement Letter
          </button>
        </div>

        <button *ngIf="(currentReport?.STAGE?.ID === 'ELST' && currentReport.showEngage()) || currentReport?.STAGE?.ID === 'ELRD'" type="button"
                class="btn btn-rbv warning full-width" (click)="engageFile()" style="margin-top: 10px;">
          Engage File
        </button>
      </div>

      <!-- Engagement Letter Documents -->
      <div class="section-block mt-3" *ngIf="currentReport.DOCUMENTS.length > 0">
        <div class="section-header" (click)="isCollapsed = !isCollapsed"
             [attr.aria-expanded]="!isCollapsed" aria-controls="collapseEvent">
          <fa [name]="isCollapsed ? 'fa fa-minus' : 'fa fa-plus'"></fa>
          <div class="text">Documents</div>
        </div>

        <div class="report-summary" [collapse]="!isCollapsed">
          <div class="document-wrapper mt-1" *ngFor="let doc of currentReport.DOCUMENTS">
             <!-- Document-->
            <div class="row">
              <div class="col-4">
                <div class="label">Document:</div>
              </div>
              <div class="col-6" [ngSwitch]="doc.DOCUMENT_TYPE">
                <div class="value" *ngSwitchCase="DocumentType.ENGAGEMENT_LETTER">
                  Engagement Letter
                </div>
              </div>

              <div class="col-1">
                <div class="btn-rbv-dropdown" dropdown>
                  <button dropdownToggle type="button" class="btn-option">
                    <i class="fa fa-cog" style="font-size: 20px; color: gray;"></i>
                  </button>

                  <div *dropdownMenu class="drop-menu dropdown-menu-right" style="width: 200px;">
                    <a *ngIf="!doc.IS_MANUAL && doc.DOCUMENT_STATE === RSState.pending" class="drop-item" (click)="remindClientEngLetter(doc)">
                      <i class="fa fa-send"></i>
                      <div class="item">Remind Client</div>
                    </a>

                    <a *ngIf="!doc.IS_MANUAL" class="drop-item" (click)="downloadDocumentZip($event, doc)">
                      <i class="fa fa-file-archive-o" *ngIf="!isDownloadZipLoading"></i>
                      <span class="loading-icon-small" *ngIf="isDownloadZipLoading"></span>
                      <div class="item">Download Zip</div>
                    </a>

                    <a class="drop-item" (click)="downloadDocument($event, doc)">
                      <i class="fa fa-file-pdf-o" *ngIf="!isDownloadCombineLoading"></i>
                      <span class="loading-icon-small" *ngIf="isDownloadCombineLoading"></span>
                      <div class="item">Download Combined</div>
                    </a>

                    <a class="drop-item" *ngIf="!doc.IS_MANUAL && (doc.DOCUMENT_STATE !== RSState.voided)"
                      (click)="voidDocument(doc)">
                      <i class="fa fa-ban" style="color: red"></i>
                      <div class="item">Void Document</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <!-- Document ID -->
            <!--  <div class="row">
              <div class="col-12 ref_id">
                {{currentReport.DOCUMENT_ID}}
              </div>
            </div> -->

            <!-- State -->
            <div class="row">
              <div class="col-4">
                <div class="label">State:</div>
              </div>

              <div class="col-6">
                <div *ngIf="!doc.IS_MANUAL" [ngSwitch]="doc.DOCUMENT_STATE">
                  <div class="state value" *ngSwitchCase="RSState.draft">
                    Draft
                  </div>
                  <div class="state value" *ngSwitchCase="RSState.pending">
                    Pending
                  </div>
                  <div class="state value" *ngSwitchCase="RSState.executed">
                    Executed
                  </div>
                  <div class="state value" *ngSwitchCase="RSState.voided">
                    Voided
                  </div>
                  <div class="state value" *ngSwitchCase="RSState.expired">
                    Expired
                  </div>
                </div>
                <span *ngIf="doc.IS_MANUAL" style="font-weight: bold;color: red;">Engaged Manually</span>
              </div>

              <!-- <div class="col-2">
                <custom-download-preview [previewOnly]="true" [report]="currentReport"></custom-download-preview>
              </div> -->
            </div>

            <!-- Created -->
            <div class="row">
              <div class="col-4">
                <div class="label">Created:</div>
              </div>
              <div class="col-7">
                <div class="date value hinted">
                  {{doc.SUBMIT_DATE | amTimeAgo}}
                  <div class="hint">{{currentReport.SUBMIT_DATE | date: 'MM/dd/yy hh:mm:ss a'}}</div>
                </div>
              </div>
            </div>

            <!-- Executed -->
            <div class="row" *ngIf="doc.DOCUMENT_STATE === RSState.executed">
              <div class="col-4">
                <div class="label">Executed:</div>
              </div>
              <div class="col-7">
                <div class="date value hinted">
                  {{doc.EXECUTE_DATE | amTimeAgo}}
                  <div class="hint">{{doc.EXECUTE_DATE | date: 'MM/dd/yy hh:mm:ss a'}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #businessFormHelpText>
  <div class="formart-wrapper container">
    <table class="table">
      <thead>
        <tr>
          <th>Type of Business</th>
          <th>Form</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let h of helperTexts">
          <td>{{h.BUSINESS}}</td>
          <td>{{h.FORM}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<template #target></template>
